import { render } from "./ProductSegmentEditBox.vue?vue&type=template&id=84586c9a&scoped=true"
import script from "./ProductSegmentEditBox.vue?vue&type=script&lang=js"
export * from "./ProductSegmentEditBox.vue?vue&type=script&lang=js"

import "./ProductSegmentEditBox.vue?vue&type=style&index=0&id=84586c9a&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84586c9a"]])

export default __exports__